import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-canvas text-ink">
      <Navbar />
      <main className="flex-1 pt-20" data-testid="app-main">
        {children}
      </main>
      <Footer />
    </div>
  );
}
